import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import PrivateRoute from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage/LoginPage";
import AdminBotInsertsPage from "./pages/AdminBotInsertsPage/AdminBotInsertsPage";
import AdminCleanupPage from "./pages/AdminCleanupPage/AdminCleanupPage";
import AdminImportsPage from "./pages/AdminImportsPage/AdminImportsPage";
import AdminQuestionsPage from "./pages/AdminQuestionsPage/AdminQuestionsPage";
import AdminResultsPage from "./pages/AdminResultsPage/AdminResultsPage";
import AdminStudentsPage from "./pages/AdminStudentsPage/AdminStudentsPage";
import ChooseTask from "./pages/Task/ChooseTask/ChooseTask";
import StartTaskPage from "./pages/Task/StartTaskPage/StartTaskPage";
import TaskInfoPage from "./pages/Task/TaskInfoPage/TaskInfoPage";
import TaskPage from "./pages/Task/TaskPage/TaskPage";
import TaskResultPage from "./pages/Task/TaskResultPage/TaskResultPage";
import TaskReviewPage from "./pages/Task/TaskReviewPage/TaskReviewPage";
import ChooseTest from "./pages/Test/ChooseTest/ChooseTest";
import TestInfoPage from "./pages/Test/TestInfoPage/TestInfoPage";
import TestPage from "./pages/Test/TestPage/TestPage";
import TestProtocolPage from "./pages/Test/TestProtocolPage/TestProtocolPage";
import TestResultsPage from "./pages/Test/TestResultsPage/TestResultsPage";
import TestReviewPage from "./pages/Test/TestReviewPage/TestReviewPage";

const ADMIN_ROLES = ["admin", "superadmin"];
const SUPERADMIN_ROLES = ["superadmin"];

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />

        <Route
          path="/admin/students"
          element={
            <PrivateRoute allowedRoles={ADMIN_ROLES}>
              <AdminStudentsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/questions"
          element={
            <PrivateRoute allowedRoles={ADMIN_ROLES}>
              <AdminQuestionsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/results"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminResultsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/imports"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminImportsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/import-history"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminImportsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/bot-inserts"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminBotInsertsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/clipboard-logs"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminBotInsertsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/task-review"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <TaskReviewPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/superadmin/results"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminResultsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/students"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminStudentsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/questions"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminQuestionsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/imports"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminImportsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/import-history"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminImportsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/bot-inserts"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminBotInsertsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/clipboard-logs"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminBotInsertsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/cleanup"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <AdminCleanupPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/superadmin/task-review"
          element={
            <PrivateRoute allowedRoles={SUPERADMIN_ROLES}>
              <TaskReviewPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/choose-test"
          element={
            <PrivateRoute allowedRoles={["test"]}>
              <ChooseTest />
            </PrivateRoute>
          }
        />
        <Route
          path="/test"
          element={
            <PrivateRoute allowedRoles={["test"]}>
              <TestPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/test-review"
          element={
            <PrivateRoute allowedRoles={["test"]}>
              <TestReviewPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/test-result"
          element={
            <PrivateRoute allowedRoles={["test"]}>
              <TestResultsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/test-protocol/:attemptId"
          element={
            <PrivateRoute allowedRoles={["test"]}>
              <TestProtocolPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/test-info"
          element={
            <PrivateRoute allowedRoles={["test"]}>
              <TestInfoPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/choose-task"
          element={
            <PrivateRoute allowedRoles={["task"]}>
              <ChooseTask />
            </PrivateRoute>
          }
        />
        <Route
          path="/task-result"
          element={
            <PrivateRoute allowedRoles={["task"]}>
              <TaskResultPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/task-info"
          element={
            <PrivateRoute allowedRoles={["task"]}>
              <TaskInfoPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/start-task"
          element={
            <PrivateRoute allowedRoles={["task"]}>
              <StartTaskPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/task"
          element={
            <PrivateRoute allowedRoles={["task"]}>
              <TaskPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/task-review"
          element={
            <PrivateRoute allowedRoles={["task"]}>
              <TaskReviewPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
